import { createRouter, createWebHistory } from 'vue-router';
import WelcomeView from '../views/Welcome.vue';
import QRScannerView from '../views/QRScanner.vue';
import ChecklistPage from '../views/Checklist.vue'; // Geänderter Import
import BranchesView from '../views/Branches.vue'; // Änderung hier

const routes = [
  { path: '/', name: 'WelcomePage', component: WelcomeView },
  { path: '/qr-scanner', name: 'QRScanner', component: QRScannerView },
  { path: '/checklist', name: 'ChecklistPage', component: ChecklistPage }, // Geänderter Name
  { path: '/branches', name: 'Branches', component: BranchesView }, // Änderung hier
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
